import React from "react";
import { View, StyleSheet } from "react-native";
import BaseExtensionController from "./BaseExtensionController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtListRow from "../../components/NtListRow";
import NtBadge from "../../components/NtBadge";
import { fetchPbxCdrs } from "../../api/cdr";
import { asyncStorageSetData } from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import pbxcdrcsvcolumndata from "../data/pbxcdrcsvcolumndata";

class PbxCdrController extends BaseExtensionController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    page: 1,
  };

  column_location = "@pbxcdr_column_storage";

  componentDidMount() {
    super.componentDidMount?.();
    this.handleDefaultColumnsFetch(
      this.column_location,
      pbxcdrcsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    const domain = this.context?.user?.domain;
    const extension = this.props.route?.params?.extension;
    if (!domain || !extension) return;
    this.setState({ loading: true });
    const res = await fetchPbxCdrs(domain, extension, this.state.page, settings.pageSizeLoad);
    Logger("PbxCdrs fetch response", res);
    if (res.ok) {
      this.setState({
        data: res.data?.data || [],
        totalItems: res.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const domain = this.context?.user?.domain;
    const extension = this.props.route?.params?.extension;
    const res = await fetchPbxCdrs(domain, extension, 1, 10000000);
    return res.ok ? res.data?.data || [] : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "duration") return item[column] ? `${item[column]}s` : "";
    return item[column];
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  renderRow = (item, index) => (
    <NtListRow
      key={item.xml_cdr_uuid || item.id || index}
      item={item}
      columns={this.state.columns}
      renderCustom={(row, column) => {
        if (column === "duration") return row[column] ? `${row[column]}s` : "—";
        if (column === "hangup_cause") {
          const ok = row[column] === "NORMAL_CLEARING";
          return (
            <NtBadge variant={ok ? "green" : "gray"}>
              {row[column] || "—"}
            </NtBadge>
          );
        }
      }}
    />
  );

  render() {
    const extension = this.props.route?.params?.extension;
    const subtitle = `${this.state.totalItems || 0} call${this.state.totalItems === 1 ? "" : "s"}`;

    return (
      <NtRootPageContainer
        pageTitle={`CDR · Ext ${extension || "—"}`}
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        showBackButton
      >
        <NtPageSection
          title="Call History"
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              columns={pbxcdrcsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="pbx-cdr"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default PbxCdrController;
